
import React from 'react';
import { Helmet } from 'react-helmet';

const AccessibilityPage = () => {
  return (
    <div className="bg-secondary text-text-light py-24">
      <Helmet>
        <title>Accessibility Statement | Aletheia Systems</title>
        <meta name="description" content="Aletheia Systems is committed to ensuring our website is accessible to everyone. Read our accessibility statement to learn about our commitment to user-friendly design." />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-center mb-12">Accessibility Statement</h1>
        <div className="prose prose-invert max-w-none">
          <p>Aletheia Systems is committed to making our website's content accessible and user-friendly to everyone.</p>
          <p>If you are having difficulty viewing or navigating the content on this website, or notice any content, feature, or functionality that you believe is not fully accessible to people with disabilities, please call our Customer Service team at +1 404 282 7007 or email us at info@aletheiasystems.com with “Disabled Access” in the subject line. Kindly provide a description of the specific feature you feel is not fully accessible or share a suggestion for improvement.</p>
          <p>We take your feedback seriously and will consider it as we evaluate ways to accommodate all of our users and improve our overall accessibility policies. Additionally, while we do not control third-party vendors, we strongly encourage vendors of third-party digital content to provide content that is accessible and user-friendly.</p>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityPage;
